module.exports = __webpack_public_path__ + "static/media/fig_14a.56529c3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_14a.jpg
// module id = 642
// module chunks = 0